import typeToReducer from "type-to-reducer";
import {
  GET_ALERTS_SUCCESS,
  GET_MONITORINGS_SUCCESS,
  GET_ORDERS_SUCCESS,
  GET_ORDER_SUCCESS,
  GET_RESTAURANTS_SUCCESS,
  GET_ALERT_SUCCESS
} from "../actions/actionTypes";

const initialState = {
  alerts: null,
  alert: null,
  monitorings: null,
  orders: null,
  order: null,
  ordersPageCount: null,
  restaurants: null,
  restaurant: null,
  user: null,
  driver: null,
  branch: null
};

const reducer = typeToReducer(
  {
    [GET_ALERTS_SUCCESS]: (state, action) => ({
      ...state,
      alerts: action.payload.results
    }),
    [GET_ALERT_SUCCESS]: (state, action) => ({
      ...state,
      alert: action.payload
    }),
    [GET_MONITORINGS_SUCCESS]: (state, action) => ({
      ...state,
      monitorings: action.payload
    }),
    [GET_ORDERS_SUCCESS]: (state, action) => ({
      ...state,
      orders: action.payload.results,
      ordersPageCount: Math.ceil(action.payload.count / 10)
    }),
    [GET_ORDER_SUCCESS]: (state, action) => ({
      ...state,
      order: action.payload
    }),
    [GET_RESTAURANTS_SUCCESS]: (state, action) => ({
      ...state,
      restaurants: action.payload.results
    }),
    "GET_USER_SUCCESS": (state, action) => ({
      ...state,
      user: action.payload
    }),
    "GET_DRIVER_SUCCESS": (state, action) => ({
      ...state,
      driver: action.payload
    }),
    "GET_RESTAURANT": (state, action) => ({
      ...state,
      restaurant: action.payload
    }),
      "GET_BRANCH": (state, action) => ({
          ...state,
          branch: action.payload
      })
  },
  initialState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/operations.js